import { doRequest as d } from "../unitl/doRequest";
export function PostRegister(mobile: number, nickname: string, password: string, qq: string = "", email: string = "") {
  return d.post("/v1/user/register", {
    mobile,
    nickname,
    password,
    qq,
    email,
  });
}

/**
 * 登录
 * @param mobile
 * @param password
 */
export function PostLogin(mobile: string, password: string): Promise<{ access_token: string; user: object }> {
  return d.post("/v1/user/login", { mobile, password });
}
/**
 * 获取验证码
 * @param mobile
 */
export function PostGetSmsCode(mobile: string): Promise<{ msg: string}> {
  return d.post("/v1/sms/get_sms_code", { mobile });
}
/**
 * 验证码登录
 * @param mobile
 * @param sms_code
 */
export function PostCodeLogin(mobile: string, sms_code: string): Promise<{ access_token: string; user: object }> {
  return d.post("/v1/sms/login", { mobile, sms_code });
}

/**
 * 登出
 */
export function PostLogout() {
  return d.post("/v1/user/logout");
}

/**
 * 生成装备图片
 */
export function CreateImage(steam_id: string, valuation: 1 | 2 = 1): Promise<{ image: string }> {
  return d.post("/v1/inventory/image", { steam_id, valuation });
}

/**
 * 获取装备列表
 * @param steam_id
 */
export function GetImageList(steam_id: string) {
  return d.get("/v1/newinventory/get-list", { params: { steam_id } });
}
/**
 * 获取素材列表
 */
export function GetSuitshowList(steam_id: string) {
  return d.get("/v1/inventory/valuation-suitshow",{ params: { steam_id } });
}

/**
 * 获取素材列表
 */
export function GetMaterial() {
  return d.get("/v1/inventory/get-material");
}
/**
 * 保存stream_id等级信息
 * @param steam_id
 * @param classid
 * @param level
 */
export function SaveLevel(steam_id: string,classid: string,level: any) {
  return d.post("/v1/inventory/save-level", { steam_id, classid,level });
}
/**
 * 保存stream_id等级信息
 * @param steam_id
 * @param classid
 * @param level
 */
export function SaveValuationLog(steam_id: string,valuation: string,grade: any) {
  return d.post("/v1/inventory/save-valuation-log", { steam_id, valuation,grade });
}

/**
 * 分页获取用户作图记录
 */
export function GetValuationCollectionLogList(steam_id: string,startDate: string,endDate: string,page: number) {
  return d.post("/v1/inventory/get-valuation-collection-log-list",{ steam_id,startDate,endDate,page });
}
/**
 * 分页获取用户估价记录
 */
export function GetValuationLogLists(steam_id: string,startDate: string,endDate: string,page: number) {
  return d.post("/v1/inventory/get-valuation-log-list",{ steam_id,startDate,endDate,page });
}
/**
 * 分页获取用户采集记录
 */
export function GetValuationImageList(steam_id: string,startDate: string,endDate: string,page: number) {
  return d.post("/v1/inventory/get-valuation-image-list",{ steam_id, startDate,endDate,page });
}
/**
 * 上传图片
 * @param steam_id
 * @param classid
 * @param level
 */
export function SaveValuationImage(steam_id: string,image: string,type: string) {
  return d.post("/v1/inventory/save-valuation-image", { steam_id,image, type });
}
/**
 * 获取永劫无间列表
 */
export function GetYjwjData() {
  return d.get("/v1/newinventory/yjwj-data",{});
}
export function GetYjwjData2() {
  return d.get("/v1/inventory/yongjiewujian",{});
}
export function GetYsData() {
  return d.get("v1/ys/getData",{});
}
export function GetApexData() {
  return d.get("v1/apex/getData",{});
}
export function loadBase64Img(icon_id: string) {
  return d.get(`/v1/inventory/get-icon/${icon_id}`);
}

/**
 * 排序后生成图片
 * @param steam_id
 * @param classid_list
 * @param bg_color
 */
export function SortImageList(
  steam_id: string,
  classid_list: string,
  bg_color: string,
  bg_image: string,
  show_name: number
) {
  return d.post("/v1/newinventory/image-by-classid", { steam_id, classid_list, bg_color, bg_image, show_name });
}

/**
 * qq扫码登录
 * @param params
 */
export function qqLogin(params: object) {
  return d.get("/v1/zb/qqlogin",{ params: params });
}
/**
 * qq扫码登录
 * @param params
 */
export function wxLogin(params: object) {
  return d.get("/v1/zb/wxlogin",{ params: params });
}

/**
 * 获取角色列表
 * @param params
 */
export function HpjyRoleList(params: object) {
  return d.get("/v1/zb/htjy-rolelist",{ params: params });
}



/**
 * 王者营地获取基本信息
 * @param params
 */
export function getUserAdapter(params: object) {
  return d.get("/v1/wzry/get-user-adapter",{ params: params });
}
